import { setState } from './helpers'

const uiMutations = {
  ADJUST_PENDING(state, delta) {
    state.pendingRequests = Math.max(0, state.pendingRequests + delta)
  },
  SET_REGISTER_ERRORS: setState('registerError'),
  SET_IS_LOADING: setState('isLoading'),
  SET_MENU_VISIBLE: setState('menuVisible'),

  toggleSidebar(state) {
    state.sidebarVisible = !state.sidebarVisible
  },
  toggleUnfoldable(state) {
    state.sidebarUnfoldable = !state.sidebarUnfoldable
  },
  updateSidebarVisible(state, payload) {
    state.sidebarVisible = payload.value
  },

  SET_TOAST(state, payload) {
    if (payload) {
      state.toast.push(payload)
    } else {
      state.toast = []
    }
  }
}

export { uiMutations }
